// import Tabs from "@ds/components/Tabs";
// import SearchBox from "@atoms/SearchBox";
// import Filter from "@atoms/Filter";
// import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
// import { SearchIcon } from "@icons/index";
// import GlobalSearch from "@layouts/Main/lib/Header/lib/GlobalSearch";
import { useState } from "react";
import { useRouter } from "next/router";
import { Box, Grid } from "@mui/material";
import Text from "@ds/components/Text";
import { HeadAndFilterProps } from "../interface";
import useStyles from "./styles";
import color from "@definitions/mui/color";
import { useWindowScroll } from "react-use";
import clsx from "clsx";
import { useTranslation } from "next-i18next";
import dynamic from "next/dynamic";

const KeyboardBackspaceIcon = dynamic(() => import("@mui/icons-material/KeyboardBackspace"));
const SearchIcon = dynamic(() => import("@icons/index").then(mod => mod.SearchIcon));
const GlobalSearch = dynamic(() => import("@layouts/Main/lib/Header/lib/GlobalSearch"));
const Tabs = dynamic(() => import("@ds/components/Tabs"));
const SearchBox = dynamic(() => import("@atoms/SearchBox"));
const Filter = dynamic(() => import("@atoms/Filter"));

const Mobile = ({
  tabs,
  search,
  title,
  filter,
  goBack,
  actionButton,
  onBack,
  isScrolled,
  handleSearchIconClick,
  noShadow,
  // isGlobalSearch,
  className,
  child,
  expand,
  isDashboardGlobalSearch,
  isMobilePwa,
  positionGap
}: HeadAndFilterProps) => {
  const router = useRouter();
  const classes = useStyles({
    tabs: Boolean(tabs || expand || child),
    isSelected: Boolean(filter?.selected.length),
    staticHeight: Boolean(filter?.staticHeight),
    positionGap: positionGap
  });

  const [searchInput, setSearchInput] = useState("");
  const { t } = useTranslation("common");

  const _onBack = () => {
    if (onBack) {
      onBack();
    } else {
      router.back();
    }
  };

  const { y } = useWindowScroll();

  return (
    <Box>
      {(tabs || title || goBack || child || expand) && (
        <Box
          className={classes.headerWrapper}
          sx={{
            boxShadow: !!noShadow || y === 0 ? 0 : "0px 6px 12px rgba(46, 67, 77, 0.1)",
            borderBottom: tabs ? `1px solid ${color.grey.light}` : 0,
          }}
        >
          <Box className={classes.header}>
            <Box display="flex" alignItems="center" justifyContent="space-between" width="100%">
              <Box sx={{ display: "flex" }}>
                {goBack && (
                  <Box onClick={_onBack} className={classes.clickableIcon}>
                    <KeyboardBackspaceIcon
                      sx={{ fontSize: 40, width: "24px !important", height: "auto !important" }}
                    />
                  </Box>
                )}
                <Text variant="h3">{title}</Text>
              </Box>
              <Box>
                <Grid container spacing={3}>
                  {expand?.map((item: any) => {
                    return (
                      <Grid item>
                        <Box onClick={item.onClick}>{item.component}</Box>
                      </Grid>
                    );
                  })}
                  {isScrolled && !isMobilePwa && (
                    <Grid item>
                      <SearchIcon className={classes.icon} onClick={handleSearchIconClick} />
                    </Grid>
                  )}
                  {/* {isScrolled && isGlobalSearch && (
                    <Grid item>
                      <GlobalSearch />
                    </Grid>
                  )} */}
                </Grid>
              </Box>
            </Box>
            {actionButton && (
              <Box display="flex" alignItems="center">
                {actionButton}
              </Box>
            )}
          </Box>
          {isMobilePwa ? (
            <Box sx={{ width: "100%" }}>
              <SearchBox
                onChange={(val: string) => {
                  setSearchInput(val);
                }}
                onKeyDown={(evt: React.KeyboardEvent<HTMLInputElement>) => {
                  if (evt.key === "Enter" && searchInput !== "") {
                    setSearchInput("");
                    router.push({ pathname: `/search/${searchInput}`, query: { tab: "product" } });
                  }
                }}
                value={searchInput || ""}
                placeholder={t("search.placeholder")}
                style={{
                  fontSize: 14,
                  height: 36,
                  backgroundColor: "#FFF",
                  border: "1px solid #DEE3ED",
                }}
              />
            </Box>
          ) : null}
          {tabs && (
            <Box>
              <Tabs {...tabs} />
            </Box>
          )}
          {child && <Box>{child}</Box>}
        </Box>
      )}
      {(search || filter || isDashboardGlobalSearch) && (
        <Box className={clsx(classes.tools, className)}>
          {isDashboardGlobalSearch && <GlobalSearch isDashboardGlobalSearch />}
          {search && (
            <Box sx={{ width: "100%" }}>
              <SearchBox
                {...search}
                style={{
                  fontSize: 14,
                  height: 36,
                  backgroundColor: "#FFF",
                  border: "1px solid #DEE3ED",
                }}
              />
            </Box>
          )}
          {filter && (
            <Box>
              <Filter {...filter} />
            </Box>
          )}
        </Box>
      )}
    </Box>
  );
};

export default Mobile;
